import axios from "axios";
import { LearnersDashboard } from "../../../../../helper/base_url";

const getLearningPathData = async (learningPath, courses, projects, setResponseData) => {
  if (!learningPath || !Array.isArray(courses) || !Array.isArray(projects)) {
    //console.error("Invalid parameters for API call.");
    return;
  }

  try {
    const { data } = await axios.post(
      `${LearnersDashboard}`,
      { learningPath, category: "EMBEDDED", courses, projects },
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    );

    setResponseData(data);
  } catch (error) {
    //console.error("Error fetching learning path data:", error);
  }
};

export default getLearningPathData;